import { SecurityChartsState } from '@pages/executive-reports-old/components/executive-reports-tabs/security/store/states/security-charts.state';
import { SecuritySelectedModuleSubOrganizationsState } from '@pages/executive-reports-old/components/executive-reports-tabs/security/store/states/selected-module-sub-organizations.state';

export const securityStates = [SecurityChartsState, SecuritySelectedModuleSubOrganizationsState];
